<!-- =========================================================================================
    File Name: Invoice.vue
    Description: Invoice Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="invoice-page">

        <div class="flex flex-wrap items-center justify-between">          
          <div class="flex items-center">            
            <vs-button class="mb-base mr-3" icon-pack="feather" icon="icon icon-printer" @click="printInvoice">Imprimir</vs-button>
            <vs-button class="mb-base mr-3" type="border" color="dark" @click="voltar">{{ $t('Btn_Voltar') }}</vs-button>             
          </div>
        </div>

        <vx-card id="invoice-container">
            <div class="vx-row leading-loose">                
                <div class="vx-col w-full">
                    <h1>Evento: {{registroOriginal.tipoImagem}} - {{registroOriginal.placa}} {{registroOriginal.hasOwnProperty('labelVeiculo') && registroOriginal.labelVeiculo ? ' - ' + registroOriginal.labelVeiculo: ''}}</h1>
                    <p>{{registroOriginal.dadosVeiculo}}</p>
                    <p>cadastrado em {{registroOriginal.dataHoraCadastrado}}</p>
                    <p v-if="registroOriginal.dataHoraAvisoEmail">lembrete enviado em {{registroOriginal.dataHoraAvisoEmail}}</p>
                    <p class="flex items-center">
                        <feather-icon icon="MailIcon" svgClasses="h-4 w-4"></feather-icon>
                        <span class="ml-2" style="white-space: pre-wrap;">{{ registroOriginal.email }}</span>
                    </p>  
                </div>
            </div>
            <div class="vx-row leading-loose mt-8">                
                <div class="vx-col w-1/2">                    
                    <div class="invoice__invoice-detail">
                        <h6>EVENTO NO.</h6>
                        <p>{{ registroOriginal.numeracao }}</p>

                        <h6 class="mt-4">EVENTO</h6>
                        <p>{{ registroOriginal.nome }}</p>
                       
                    </div>
                </div>
                <div class="vx-col w-1/2">
                    <h5>PARÂMETROS DO AGENDAMENTO</h5>
                    <div class="invoice__recipient-info my-4">
                        <p v-if="registroOriginal.dataFormatado"> 
                            <feather-icon icon="CalendarIcon" svgClasses="h-4 w-4"></feather-icon>
                            <strong class="ml-2">DATA AGENDADA:</strong> {{ registroOriginal.dataFormatado }}
                        </p>                        
                        <p v-if="registroOriginal.km"> <feather-icon icon="MoreHorizontalIcon" svgClasses="h-4 w-4"></feather-icon>
                            <strong class="ml-2">KM AGENDADO:</strong> {{ registroOriginal.km }}
                            <strong class="ml-2">ATUAL:</strong> {{ registroOriginal.odometroAtualVeculo }}
                        </p>
                        <p v-if="registroOriginal.horimetro"> <feather-icon icon="ClockIcon" svgClasses="h-4 w-4"></feather-icon>
                            <strong class="ml-2">H. AGENDADO:</strong> {{ registroOriginal.horimetro }}
                            <strong class="ml-2">ATUAL:</strong> {{ registroOriginal.horimetroAtualVeculo }}
                        </p>                        
                    </div>                    
                </div>               
            </div>

             <div class="vx-row leading-loose mt-8">                
                <div class="vx-col w-full">      
                     <h6 class="mt-4">DESCRIÇÃO</h6>
                        <p style="white-space: pre-wrap;">{{ registroOriginal.descricao }}</p>
                </div>
             </div>    

            <h5 class="mt-8" v-if="registroOriginal.innerLista && registroOriginal.innerLista.length > 0"> ITENS DO EVENTO ({{registroOriginal.innerLista.length}}) </h5>
            <div class="mt-8" v-if="registroOriginal.innerLista && registroOriginal.innerLista.length > 0">            
                <vs-table hoverFlat :data="registroOriginal.innerLista" style="border-collapse: collapse;" >
                    <template slot="thead">
                        <vs-th style="width: 80px"  class="p-0">CÓDIGO</vs-th>
                        <vs-th style="width: 300px" class="p-0">DESCRIÇÃO</vs-th>
                        <vs-th style="width: 100px" class="p-0">STATUS</vs-th>
                        <vs-th>OBSERVAÇÃO</vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr v-for="(tr, index) in data" :key="index" style="border-bottom: 1px solid #636262;">
                            <vs-td :data="data[index].codigo" class="p-0"><small>{{ data[index].codigo }}</small></vs-td>
                            <vs-td :data="data[index].descricao" class="p-0"><small>{{ data[index].descricao }}</small></vs-td>
                            <vs-td :data="data[index].statusRealizado" class="p-0">
                                <small v-if="data[index].statusRealizado">{{ data[index].statusRealizado }}</small>
                                <div class="flex items-center">
                                    <vs-checkbox><small>SIM</small></vs-checkbox>                            
                                    <vs-checkbox><small>NÃO</small></vs-checkbox>                            
                                </div>
                            </vs-td>
                            <vs-td :data="data[index].observacao" class="p-0"><small>{{ data[index].observacao }}</small></vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
               
            </div>

            
            <div class="invoice__footer mt-8">
                <vs-row class="mb-8">
                    <vs-col vs-type="flex" vs-align="center" vs-w="12">
                            <h5 style="w-full">ASSINATURAS DOS RESPONSÁVEIS</h5>
                    </vs-col>
                </vs-row> 
                <vs-row class="mb-8">
                    <vs-col vs-type="flex" vs-align="center" vs-w="3">
                        <small class="font-semibold">ENCARREGADO:</small>
                        <hr class="w-full ml-2 mr-2  mt-2"/>
                    </vs-col>                    
                     <vs-col vs-type="flex" vs-align="center" vs-w="3">
                        <small class="font-semibold">MECÂNICO:</small>
                        <hr class="w-full ml-2 mr-2  mt-2"/>
                    </vs-col>                    
                    <vs-col vs-type="flex" vs-align="center" vs-w="3">
                        <small class="font-semibold ">ELETRICISTA:</small>
                        <hr class="w-full ml-2 mr-2 mt-2"/>
                    </vs-col> 
                    <vs-col vs-type="flex" vs-align="center" vs-w="3">
                        <small class="font-semibold ">MOTORISTA:</small>
                        <hr class="w-full ml-2 mr-2 mt-2"/>
                    </vs-col>                    
                </vs-row> 

                <vs-row class="mt-8">
                    <vs-col vs-type="flex" vs-align="center" vs-w="3">
                        <small class="font-semibold">BORRACHEIRO:</small>
                        <hr class="w-full ml-2 mr-2  mt-2"/>
                    </vs-col>                    
                     <vs-col vs-type="flex" vs-align="center" vs-w="3">
                        <small class="font-semibold">LUBRIFICADOR:</small>
                        <hr class="w-full ml-2 mr-2  mt-2"/>
                    </vs-col>                    
                    <vs-col vs-type="flex" vs-align="center" vs-w="3">
                        <small class="font-semibold ">LANTERNEIRO:</small>
                        <hr class="w-full ml-2 mr-2 mt-2"/>
                    </vs-col>                    
                    <vs-col vs-type="flex" vs-align="center" vs-w="3">
                        <small class="font-semibold ">OPERADOR:</small>
                        <hr class="w-full ml-2 mr-2 mt-2"/>
                    </vs-col>                    
                </vs-row> 

            </div>
        </vx-card>
    </div>
</template>

<script>

const NAME_ROUTE_EDIT = "frota-agenda-eventos-edit";

export default{
    props: {
        registroOriginal: {
        type: Object,
        required: true        
        },
    },
    data() {
        return {
            
        }
    },
    computed: {

    },
    methods: {
      printInvoice() {
        window.print()
      },
      voltar(){
          this.$router.push({
            name: NAME_ROUTE_EDIT,
            params: {
              registroOriginal: this.registroOriginal
            }
      })
      }
    },
    components: {},
    mounted() {
      this.$emit("setAppClasses", "invoice-page")
    }
}
</script>

<style lang="scss">
@media print {
  body{
    background-color:white !important;      
  }
  .invoice-page {
    * {
      visibility: hidden;
      background-color:white !important;      
      -webkit-print-color-adjust: exact; 
    }

    #content-area {
      margin: 0 !important;
    }

    #invoice-container,
    #invoice-container * {
      visibility: visible;
       h1, h2, h3, h4, h5, h6, p, span, svg, small, input {
        color: rgba(0, 0, 0, 0);
        text-shadow: 0 0 0 rgb(0, 0, 0);        
      }      
    }
    #invoice-container {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;      
    }
  }
}

</style>
